import { Routes, Route } from "react-router-dom";
import { ModuleErrorBoundary } from "@hub/ui/components/ErrorBoundary";
import { LoginPage } from "@hub/auth";

export function AuthRoutes() {
  return (
    <ModuleErrorBoundary moduleName="Authentication">
      <Routes>
        <Route index element={<LoginPage appName="Workbench" />} />
      </Routes>
    </ModuleErrorBoundary>
  );
}
